import { KnowledgeAssetSubTypeEnum } from '@/types/schema';

export const KNOWLEDGE_ASSET_TEMPLATE_PAGE_TITLE_KEY: Record<KnowledgeAssetSubTypeEnum, string> = {
  [KnowledgeAssetSubTypeEnum.Solution]: 'KnowledgeAsset:Solutions',
  [KnowledgeAssetSubTypeEnum.SolutionWin]: 'KnowledgeAsset:SolutionWins',
  [KnowledgeAssetSubTypeEnum.CustomerStory]: 'KnowledgeAsset:CustomerStory',
  [KnowledgeAssetSubTypeEnum.UserJourneyPersona]: 'KnowledgeAsset:UserJourneyPersona',
  [KnowledgeAssetSubTypeEnum.Persona]: 'KnowledgeAsset:Persona',
  [KnowledgeAssetSubTypeEnum.PersonaJourney]: 'KnowledgeAsset:PersonaJourney',
  [KnowledgeAssetSubTypeEnum.SalesConversation]: 'KnowledgeAsset:SalesConversation',
};

export const KNOWLEDGE_ASSET_TEMPLATE_CREATE_PAGE_TITLE_KEY: Record<
  KnowledgeAssetSubTypeEnum,
  string
> = {
  [KnowledgeAssetSubTypeEnum.Solution]: 'KnowledgeAsset:Create.Solutions',
  [KnowledgeAssetSubTypeEnum.SolutionWin]: 'KnowledgeAsset:Create.SolutionWins',
  [KnowledgeAssetSubTypeEnum.CustomerStory]: 'KnowledgeAsset:Create.CustomerStory',
  [KnowledgeAssetSubTypeEnum.UserJourneyPersona]: 'KnowledgeAsset:Create.UserJourneyPersona',
  [KnowledgeAssetSubTypeEnum.Persona]: 'KnowledgeAsset:Create.Persona',
  [KnowledgeAssetSubTypeEnum.PersonaJourney]: 'KnowledgeAsset:Create.PersonaJourney',
  [KnowledgeAssetSubTypeEnum.SalesConversation]: 'KnowledgeAsset:Create.SalesConversation',
};

export const KNOWLEDGE_ASSET_TEMPLATE_EDIT_PAGE_TITLE_KEY: Record<
  KnowledgeAssetSubTypeEnum,
  string
> = {
  [KnowledgeAssetSubTypeEnum.Solution]: 'KnowledgeAsset:Edit.Solutions',
  [KnowledgeAssetSubTypeEnum.SolutionWin]: 'KnowledgeAsset:Edit.SolutionWins',
  [KnowledgeAssetSubTypeEnum.CustomerStory]: 'KnowledgeAsset:Edit.CustomerStory',
  [KnowledgeAssetSubTypeEnum.UserJourneyPersona]: 'KnowledgeAsset:Edit.UserJourneyPersona',
  [KnowledgeAssetSubTypeEnum.Persona]: 'KnowledgeAsset:Edit.Persona',
  [KnowledgeAssetSubTypeEnum.PersonaJourney]: 'KnowledgeAsset:Edit.PersonaJourney',
  [KnowledgeAssetSubTypeEnum.SalesConversation]: 'KnowledgeAsset:Edit.SalesConversation',
};

export const convertStringToEnum = <T extends { [key: string]: string }>(
  str: string,
  enumType: T,
): T[keyof T] | null => {
  const enumKey = str.toUpperCase().replace(/-/g, '_'); // Convert kebab-case to UPPER_SNAKE_CASE
  return Object.values(enumType).includes(enumKey as T[keyof T]) ? (enumKey as T[keyof T]) : null; // Check if the converted value exists in the enum
};

export const convertEnumToString = <T extends { [key: string]: string }>(
  enumValue: T[keyof T],
): string => {
  return enumValue.toLowerCase().replace(/_/g, '-'); // Convert UPPER_SNAKE_CASE to kebab-case
};

/**
 * Converts a knowledge asset subtype variant from UPPER_SNAKE_CASE to Title Case
 * Example: WEB_MODULE -> Web Module
 */
export const convertKnowledgeAssetSubTypeVariant = (variant: string): string => {
  return variant
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const convertEnumToReadableString = <T extends { [key: string]: string }>(
  enumValue: T[keyof T],
): string => {
  return enumValue
    .toLowerCase() // Convert to lowercase
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
};
